import { createSlice } from "@reduxjs/toolkit";
import { addEditFileFolder, getFoldersByTenantId } from "./thunks";
import { handleFileFolderMutation } from "./helper";

const initialState = {
  foldersByTenants: {},
  selectedFolderId: null,
  loading: true,
};

const spreadsheetSlice = createSlice({
  name: "spreadsheet",
  initialState,
  reducers: {
    setKeyValue: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFoldersByTenantId.pending, (state) => {
        state.loading = true;
      })
      .addCase(getFoldersByTenantId.fulfilled, (state, action) => {
        const { tenant_id } = action.meta.arg;
        const { data } = action.payload;

        state.foldersByTenants[tenant_id] =
          data.reduce((acc, item) => {
            acc[item.id || null] = item;
            return acc;
          }, {}) || {};

        state.loading = false;
      })
      .addCase(getFoldersByTenantId.rejected, (state) => {
        state.loading = false;
      })
      .addCase(addEditFileFolder.fulfilled, handleFileFolderMutation);
  },
});

export const { setKeyValue } = spreadsheetSlice.actions;

export default spreadsheetSlice.reducer;
